import {ITheme} from 'contexts/ThemeContext';
import {Platform} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle(
    {
      container: {
        flex: 1,
        backgroundColor: props.colors.dirtyWhite,
      },
      generalContainer: {},
      infoContainer: {
        marginTop: 24,
        paddingHorizontal: 30,
        marginHorizontal: 30,
        backgroundColor: props.colors.white,
        borderRadius: 20,
        borderWidth: 1,
        borderColor: props.colors.extraLight,
      },

      inputView: {
        flexDirection: 'row',
        gap: 200,
        paddingBottom: 54,
      },

      buttonStyle: {
        width: 180,
        marginTop: 10,
      },
      titleColor: {
        fontSize: 18,
        color: props.colors.white,
        ...props.typography.mulishRegular,
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {},
      [minSize(DEVICE_SIZES.MEDIUM_DEVICE)]: {},
    },
  )();
